var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_282)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0.25H0V32.25H32V0.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6313 0.25H2.3625C1.05625 0.25 0 1.28125 0 2.55625V29.9375C0 31.2125 1.05625 32.25 2.3625 32.25H29.6313C30.9375 32.25 32 31.2125 32 29.9438V2.55625C32 1.28125 30.9375 0.25 29.6313 0.25ZM9.49375 27.5187H4.74375V12.2437H9.49375V27.5187ZM7.11875 10.1625C5.59375 10.1625 4.3625 8.93125 4.3625 7.4125C4.3625 5.89375 5.59375 4.6625 7.11875 4.6625C8.6375 4.6625 9.86875 5.89375 9.86875 7.4125C9.86875 8.925 8.6375 10.1625 7.11875 10.1625ZM27.2687 27.5187H22.525V20.0938C22.525 18.325 22.4937 16.0437 20.0562 16.0437C17.5875 16.0437 17.2125 17.975 17.2125 19.9688V27.5187H12.475V12.2437H17.025V14.3313H17.0875C17.7187 13.1313 19.2688 11.8625 21.575 11.8625C26.3813 11.8625 27.2687 15.025 27.2687 19.1375V27.5187Z",
    fill: "#FF7300"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.b8525d3662a6d6c3d6d4e711064d8077.svg";
export { ForwardRef as ReactComponent };